import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";
import { PushNotifications } from "@capacitor/push-notifications";
import { api } from "../lib/api";

const pushTokenKey = "f-bucks-push-token";

export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform();
}

export async function revokeNativePushToken(): Promise<void> {
  if (!isNativeApp()) return;
  try {
    const stored = await Preferences.get({ key: pushTokenKey });
    if (stored.value) {
      await api.post("/account/push-tokens/revoke", { token: stored.value });
      await Preferences.remove({ key: pushTokenKey });
    }
    await PushNotifications.unregister();
  } catch {
    // Logout must remain possible even when the push provider is unavailable.
  }
}

export async function storeNativePushToken(token: string): Promise<void> {
  await Preferences.set({ key: pushTokenKey, value: token });
}
